/**
 * Allow-listed adapter (decision 35): the only presentation file that reads the app's auth store.
 * Signed in means a Firebase user is present, the same test ProtectedRoute uses.
 */
import { useAuthStore } from '@/store/authStore';

export function useIsSignedIn(): boolean {
  return useAuthStore((state) => state.user !== null);
}

/** The signed-in candidate's email, if any: the real identity that replaces the offer's stand-in candidate */
export function useSignedInEmail(): string | undefined {
  return useAuthStore((state) => state.user?.email ?? undefined);
}

/** The signed-in user's id, if any: what a per-candidate list reloads on */
export function useSignedInUserId(): string | undefined {
  return useAuthStore((state) => state.user?.uid ?? undefined);
}
